export type FeaturePillar = {
  id: 'build' | 'measure' | 'improve';
  eyebrow: string;
  title: string;
  summary: string;
  detail: string;
  capabilities: string[];
  image: string;
  imageAlt: string;
};

export const featurePillars: FeaturePillar[] = [
  {
    id: 'build',
    eyebrow: 'Build',
    title: 'Create agents with control',
    summary: 'Bring instructions, models, tools, and workflows into one governed workspace.',
    detail:
      'Give builders a clear place to compose the agent, select approved capabilities, and keep its operating configuration understandable.',
    capabilities: ['Agent Studio', 'Governed models and providers', 'Approved connectors and tools'],
    image: '/feature-previews/build-local-launch-planner.png',
    imageAlt:
      'Knotiv Agent Studio showing a Local Launch Planner with governed Gemini model, Google Maps connector, workflow steps, instructions, and runtime variables',
  },
  {
    id: 'measure',
    eyebrow: 'Measure',
    title: 'See the work, not just the answer',
    summary: 'Test real conversations and inspect the evidence behind every agent run.',
    detail:
      'Follow execution from prompt to outcome with the signals teams need to understand behavior, reliability, latency, token use, and estimated cost.',
    capabilities: ['Test Lab', 'Run activity and artifacts', 'Cost and usage analytics'],
    image: '/feature-previews/measure-dashboard-three-agents.png',
    imageAlt:
      'Knotiv AI Cost and Usage dashboard showing cost and token trends alongside a three-agent performance comparison',
  },
  {
    id: 'improve',
    eyebrow: 'Improve',
    title: 'Make each version more effective',
    summary: 'Compare versioned configurations and make changes with evidence instead of guesswork.',
    detail:
      'Preserve the configuration behind a result, compare snapshots side by side, and use cost, latency, and run outcomes to guide the next improvement.',
    capabilities: ['Immutable snapshots', 'Snapshot comparison', 'Versioned operational history'],
    image: '/feature-previews/improve-local-launch-planner.png',
    imageAlt:
      'Knotiv snapshot comparison showing Local Launch Planner versions side by side with cost, token, latency, and tool-use metrics',
  },
];
